define('view/controller/booking/datetime/flexible-provider/TimeFlexibleProviderItemHourItemView',['require','lib/view/LayoutView','lib/Utils'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var Utils = require('lib/Utils');

    return LayoutView.extend({

        template: '#time_flexible_provider_item_hour_item_view',

        triggers: _.extend({}, Utils.ifParams(!Utils.isIos(), {
            'click': 'select:time',
            'mouseenter': 'hover:time'
        })),

        events: _.extend({}, Utils.ifParams(Utils.isIos(), {
            'click': '_onIosClick'
        })),
        
        modelEvents: {
            'change': 'render'
        },

        _onIosClick: function () {
            var _this = this;
            this.triggerMethod('hover:time', {model: _this.model});
            setTimeout(function() {
                _this.triggerMethod('select:time', {model: _this.model});
            }, 1000);
            return false;
        },

        serializeData: function () {
            var result = LayoutView.prototype.serializeData.apply(this);
            result.time_diff = this.getOption('clientTimeZone').get('time_diff');
            result.provider = this.getOption('provider');

            return result;
        }

    });

});

